module.exports = __webpack_public_path__ + "img/icon_sportMenu_soccer.2876b22b.svg";